/**
 * internal dependencies
 */
import { awsApiInstance } from '../api/aws-api';
import { apiRetry } from '../api/api-helper';
import useAuth from '../hooks/auth-hooks';

import { ITerminalResponse } from '../models/terminal.interface';
import { handleRouteError } from './route-helpers/route-error';

/**
 * Gets an individual terminal by it's id
 * 
 * @returns {object} the api response
 */
export const displayIndividualTerminal= async ( terminalId: string ): Promise<ITerminalResponse> => {
  try {
    apiRetry(awsApiInstance);

    const { userId } = useAuth()!;

    const { data } = await awsApiInstance.get(`/terminal/${terminalId}/`, {
      params: {
        wpID: userId
      }
    });

    return data;

  } catch ( error ) {
    handleRouteError(error, 'Error getting terminal data');
    throw(error);
  }
}